/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeAUpLeftIcon16Light } from './ArrowShapeAUpLeftIcon16Light';
import { ArrowShapeAUpLeftIcon16Regular } from './ArrowShapeAUpLeftIcon16Regular';
import { ArrowShapeAUpLeftIcon16Solid } from './ArrowShapeAUpLeftIcon16Solid';
import { ArrowShapeAUpLeftIcon20Light } from './ArrowShapeAUpLeftIcon20Light';
import { ArrowShapeAUpLeftIcon20Regular } from './ArrowShapeAUpLeftIcon20Regular';
import { ArrowShapeAUpLeftIcon20Solid } from './ArrowShapeAUpLeftIcon20Solid';
import { ArrowShapeAUpLeftIcon24Regular } from './ArrowShapeAUpLeftIcon24Regular';
import { ArrowShapeAUpLeftIcon24Solid } from './ArrowShapeAUpLeftIcon24Solid';
import { ArrowShapeAUpLeftIcon32Regular } from './ArrowShapeAUpLeftIcon32Regular';
import { ArrowShapeAUpLeftIcon64Regular } from './ArrowShapeAUpLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeAUpLeftIcon16Light,
        regular: ArrowShapeAUpLeftIcon16Regular,
        solid: ArrowShapeAUpLeftIcon16Solid,
    },
    20: {
        light: ArrowShapeAUpLeftIcon20Light,
        regular: ArrowShapeAUpLeftIcon20Regular,
        solid: ArrowShapeAUpLeftIcon20Solid,
    },
    24: {
        regular: ArrowShapeAUpLeftIcon24Regular,
        solid: ArrowShapeAUpLeftIcon24Solid,
    },
    32: {
        regular: ArrowShapeAUpLeftIcon32Regular,
    },
    64: {
        regular: ArrowShapeAUpLeftIcon64Regular,
    },
};
export var ArrowShapeAUpLeftIcon = forwardRef('ArrowShapeAUpLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
